const routes = {
  '/app/push': {
    fetch: () =>
      import(/* webpackChunkName: 'push-route' */ 'app/push/asyncRoute').then(
        module => module.default
      ),
  },
};

export default routes;
